import styled from "styled-components";
import { transparentize, lighten } from 'polished';

export const defaultTheme = {
    pageBackground: '#F7F8FA',
    blue: '#0054A6',
    darkBlue: '#31658e',
    white: 'white',
    black: '#111822',
    gray: '#9ca3af',
    lightGray: '#969696',
    green: '#66D692',
    navBg: 'white',
    navText: 'black',
    liDivColor: 'black',
    liDivColorHover: 'gray',
    buttonTopColor: 'white',
    modalInActiveBgColor: 'white',
    modalInActiveColor: 'Black',
    BorderColor: 'gray',
    ButtonGreenBgColor: '#66d693',
    ButtonGreenColor: 'white',
    ButtonGreenHoverColor: '#00b050',
    ButtonThemeGreen: '#66d693',
    ButtonThemeBgGreen: 'rgba(209, 213, 219)',
    PubishIcon: '#66D692',
    sortIcon: '#2084D4',
    deleteRed: '#DC2626',
    NavBarColor: '#FFFFFF',
};

// const LightTheme = {
//     pageBackground: '#F3F6F6',
//     blue: '#2084D4',
//     darkBlue: '#31658e',
//     white: 'white',
//     black: 'black',
//     gray: '#9ca3af',
//     lightGray: '#F9F9F9',
//     green: '#66D692'
// }

// const DarkTheme = {
//     pageBackground: '#b8baba',
//     blue: '#155d96',
//     darkBlue: '#54abf0',
//     white: '#53575e',
//     black: 'white',
//     gray: '#dcdfe3',
//     lightGray: '#828181',
//     green: '#80ffb1'

// }

// export const themes = {
//     light: LightTheme,
//     dark: DarkTheme
// }

export const Page = styled.div`
    background-color: ${props => props.theme.pageBackground};
    height: 100%;
`
// export const headerDiv = styled.div`
//     background-color: ${props => props.theme.NavBarColor} !important;
// `
export const headerDiv = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.NavBarColor || '#FFFFFF';
        const lightColor = transparentize(0.85, baseColor);
        return `
      background-color: ${baseColor} !important;
    `;
    }}
`;

export const Card = styled.div`
    background-color: ${props => props.theme.white};
    color: ${props => props.theme.black};
`
export const CardNew = styled.div`
    background-color: ${props => props.theme.white};
`

export const TextGray = styled.div`
    color: ${props => props.theme.gray};
`

export const TextBlack = styled.div`
    color: ${props => props.theme.black};
`

export const TextDarkBlue = styled.div`
    color: ${props => props.theme.darkBlue};
`

export const TextGreen = styled.div`
    color: ${props => props.theme.green};
`

export const PublishIcon = styled.div`
    color: ${props => props.theme.PubishIcon};
`

export const BgWhite = styled.div`
    background-color: ${props => props.theme.white};
    color: ${props => props.theme.black};
`

export const BgBlue = styled.div`
    background-color: ${props => props.theme.blue};
`

export const BgBlueNew = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.lightGray || '#007BFF';
        const lightColor = transparentize(0.85, baseColor);
        let lightHoverColor = transparentize(0.70, baseColor);
        return `
      background-color: ${baseColor};
      color: #fff;
      border: 1px solid transaprent;
    `;
    }}
`;

export const BgComment = styled.div`
    background-color: ${props => props.theme.lightGray};
    color: ${props => props.theme.black};
`

export const BgButton = styled.div`
    background-color: ${props => props.theme.white};
    color: ${props => props.theme.gray};
    &:hover{
        background-color: ${props => props.theme.lightGray};
    }
`

export const BgPostButton = styled.div`
    background-color: ${props => props.theme.blue};
    color: ${props => props.theme.buttonTopColor};
`

export const ModalInActive = styled.div`
    background-color: ${props => props.theme.modalInActiveBgColor};
    color: ${props => props.theme.modalInActiveColor};
    border: ${props => '1px solid ' + props.theme.BorderColor};
`

export const ButtonCommonTop = styled.div`
    background-color: ${props => props.theme.blue};
    color: ${props => props.theme.buttonTopColor};  
    border: ${props => '1px solid ' + props.theme.blue};
`
export const ButtonCommonTopNew = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.blue || '#007BFF';
        const lightColor = transparentize(0.85, baseColor);
        let lightHoverColor = transparentize(0.70, baseColor);
        return `
      background-color: ${lightColor};
      color: ${baseColor};
      border: 1px solid transaprent;
      &:hover{
        background-color: ${lightHoverColor};
    }
    `;
    }}
`;
export const ButtonCommonGreen = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.ButtonGreenBgColor || '#007BFF';
        const lightColor = transparentize(0.85, baseColor);
        let lightHoverColor = transparentize(0.70, baseColor);
        return `
      background-color: ${lightColor};
      color: ${baseColor};
      border: 1px solid transaprent;
      &:hover{
        background-color: ${lightHoverColor};
    }
    `;
    }}
`;
export const DivBadge = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.blue || '#007BFF';
        const lightColor = transparentize(0.85, baseColor);
        let lightHoverColor = transparentize(0.70, baseColor);
        return `
      background-color: ${baseColor};
      color: #ffffff !important;
      border: 1px solid transaprent;
    `;
    }}
`;
export const DivBadgeNew = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.blue || '#007BFF';
        const lightColor = transparentize(0.85, baseColor);
        let lightHoverColor = transparentize(0.70, baseColor);
        return `
      background-color: ${lightColor};
      color: ${baseColor} !important;
      border: 1px solid transaprent;
    `;
    }}
`;
// export const DivBadge = styled.div`
//   ${({ theme }) => {
//         const baseColor = theme?.darkBlue || '#007BFF';
//         const lightColor = transparentize(0.85, baseColor);
//         let lightHoverColor = transparentize(0.70, baseColor);
//         return `
//       background-color: ${lightColor};
//       color: ${baseColor} !important;
//       border: 1px solid transaprent;
//       &:hover{
//         background-color: ${lightHoverColor};
//     }
//     `;
//     }}
// `;
export const ButtonCommonDelete = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.deleteRed || '#DC2626';
        const lightColor = transparentize(0.85, baseColor);
        let lightHoverColor = transparentize(0.70, baseColor);
        return `
      background-color: ${lightColor};
      color: ${baseColor};
      border: 1px solid transaprent;
      &:hover{
        background-color: ${lightHoverColor};
    }
    `;
    }}
`;
export const ButtonCommonTopGrey = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.gray || '#9ca3af';
        const lightColor = transparentize(0.85, baseColor);
        let lightHoverColor = transparentize(0.70, baseColor);

        return `
      background-color: ${lightColor} !important;
      color: ${baseColor} !important;
      border: 1px solid transaprent !important;
      &:hover{
        background-color: ${lightHoverColor};
    }
    `;
    }}
`;
export const ActionButtonTheme = styled.div`
    background-color: ${props => props.theme.blue};
    color: ${props => props.theme.white};  
    border: ${props => '1px solid ' + props.theme.blue};
`

export const ListButton = styled.li`
    background-color: ${props => props.theme.blue};
    color: ${props => props.theme.buttonTopColor};  
`

export const ShowCaseDiv = styled.div`
    color: ${props => props.theme.navText};  
    border-color: ${props => props.theme.blue};
`

export const ButtonGreenDiv = styled.div`
    background-color: ${props => props.theme.ButtonGreenBgColor};
    color: ${props => props.theme.ButtonGreenColor};
    &:hover{
        background-color: ${props => props.theme.ButtonGreenHoverColor};
    }
`

export const ButtonGridActive = styled.div`
    background-color: ${props => props.theme.white};
    color: ${props => props.theme.blue};
    &:hover{
        background-color: ${props => props.theme.white};
    }
`
export const ButtonGridActiveNew = styled.div`
    color: ${props => props.theme.blue};
`

export const ButtonGrid = styled.div`
    color: ${props => props.theme.blue};
    &:hover{
        background-color: ${props => props.theme.white};
    }
`
export const ButtonGridNew = styled.div`
    color: ${props => props.theme.gray};
`

export const SearchInput = styled.div`
    background-color: ${props => props.theme.blue};
`

export const ThemeNavActive = styled.div`
    background-color: ${props => props.theme.blue};
    color: ${props => props.theme.buttonTopColor};
`

export const ThemeNav = styled.div`
    background-color: ${props => props.theme.lightGray};
    color: ${props => props.theme.gray};
`

export const ActiveDiv = styled.div`
    background-color: ${props => props.theme.lightGray};
    color: ${props => props.theme.gray};
    }
`

export const ArchiveDiv = styled.div`
    background-color: ${props => props.theme.pageBackground};
    color: ${props => props.theme.gray};
    &:hover{
    background-color: ${props => props.theme.blue};
    color: ${props => props.theme.buttonTopColor};
    }
`

// export const NavCard = styled.ul`
//     background-color: ${props => props.theme.navBg};
//     color: ${props => props.theme.navText};
//     }
// `

// export const LiDiv = styled.div`
//     color: ${props => props.theme.liDivColor};
//     &:hover{
//     color: ${props => props.theme.liDivColorHover};
//     }
// `

export const MenuItemCard = styled.ul`
    background-color: ${props => props.theme.navBg};
    color: ${props => props.theme.navText};
    }
`
export const MenuVBE = styled.menu`
    background-color: ${props => props.theme.navBg};
    }
`

export const MenuItemDiv = styled.div`
    color: ${props => props.theme.liDivColor} !important;
`

export const SideBarActiveDiv = styled.div`
    color: ${props => props.theme.blue};
    &:hover{
    color: ${props => props.theme.blue};
    }
`

export const SideBarActiveDivNew = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.blue || '#007BFF';
        const lightColor = transparentize(0.85, baseColor);

        return `
      background-color: ${lightColor};
      color: ${baseColor};
      border-radius: 4px;
      &:hover{
      color: ${baseColor};
      background-color: ${lightColor};
    `;
    }}
`;
export const SideBarNormalDivNew = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.blue || '#007BFF';
        const lightColor = transparentize(0.85, baseColor);

        return `
      border-radius: 4px;
      &:hover{
      color: ${baseColor};
      background-color: ${lightColor};
  }
    `;
    }}
`;

export const SideBarNormalDiv = styled.div`
    &:hover{
    color: ${props => props.theme.blue};
    }
`

export const SideBarActiveDivButton = styled.button`
    color: ${props => props.theme.blue};
    &:hover{
    color: ${props => props.theme.blue};
    }
`
export const SideBarActiveDivButtonNew = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.blue || '#007BFF';
        const lightColor = transparentize(0.85, baseColor);

        return `
      background-color: ${lightColor};
      color: ${baseColor};
      border-radius: 4px;
    `;

    }}
`;
export const SideBarActiveCount = styled.span`
  ${({ theme }) => {
        const baseColor = theme?.blue || '#007BFF';
        const lightColor = transparentize(0.85, baseColor);

        return `
      background-color: ${baseColor};
      color: #ffffff;
      border-radius: 50%;
    `;

    }}
`;

export const SideBarNormalDivButton = styled.button`
    &:hover{
    color: ${props => props.theme.blue};
    }
`

export const SideBarNormalDivButtonNew = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.blue || '#007BFF';
        const lightColor = transparentize(0.85, baseColor);

        return `
      border-radius: 4px;
      &:hover{
      color: ${baseColor} !important;
      background-color: ${lightColor};
  }
      &:hover ${SideBarNormalCount} {
    background-color: ${baseColor}; /* or whatever hover effect you want */
    color: white;
  }
    `;
    }}
`;
export const SideBarNormalCount = styled.span`
  ${({ theme }) => {
        const baseColor = theme?.gray || '#007BFF';
        const lightColor = transparentize(0.85, baseColor);
        const blueColor = theme?.blue || '#007BFF';

        return `
        background-color: ${lightColor};
      color: ${baseColor};
      border-radius: 50%;
      &:hover{
      color: #ffffff !important;
      background-color: ${blueColor};
  }
    `;
    }}
`;
export const SideBarShowcase = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.black || '#000';
        const lightColor = theme?.liDivColorHover || 'gray';
        const greyColor = transparentize(0.7, lightColor);
        return `
      border-radius: 4px;
      &:hover{
      color: ${baseColor} !important;
      background-color: ${greyColor} !important;
  }
    `;
    }}
`;

export const SubNavBarActiveDiv = styled.div`
    color: ${props => props.theme.blue};
    border-color: ${props => props.theme.blue};
    &:hover{
    color: ${props => props.theme.blue};
    border-color: ${props => props.theme.blue};
    }
`
export const SubNavBarActiveDot = styled.div`
    background-color: ${props => props.theme.blue};
    height: 0.375rem;
    width: 0.375rem;
    border-radius: 50%;
    margin-right: 0.75rem;
`
export const SubNavBarNormalDot = styled.div`
    background-color: ${props => props.theme.black};
    height: 0.375rem;
    width: 0.375rem;
    border-radius: 50%;
    margin-right: 0.75rem;
`

export const SubNavBarNormalDiv = styled.div`
    color: ${props => props.theme.black};
    &:hover{
    color: ${props => props.theme.blue};
    }
`

export const ActiveIconColor = styled.div`
    color: ${props => props.theme.blue};
`

export const ActiveSpanColor = styled.span`
    color: ${props => props.theme.blue};
`

export const ActiveTopIconColor = styled.div`
    color: ${props => props.theme.modalInActiveColor};
`

export const ActiveParagraphColor = styled.p`
    color: ${props => props.theme.blue};
`

export const ActiveThemeBlackcolor = styled.div`
    color: ${props => props.theme.navText};
`
export const SelectDropDown = styled.div`
    background-color: ${props => props.theme.blue};
    color: ${props => props.theme.white};
    border-color: ${props => props.theme.blue};
    &:hover{
        background-color: ${props => props.theme.blue};
    }
`
// New Navbar Header
export const pageBackground = styled.div`
background-color: ${props => props.theme.blue};
`
export const PrivacyContainer = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.blue || '#007BFF';
        const lightColor = transparentize(0.85, baseColor);

        return `
      background-color: ${lightColor};
      color: ${baseColor};
      border: 1px solid transaprent;
    `;
    }}
`
export const IconContainerGreen = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.iconGreen || '#059669';
        const lightColor = transparentize(0.84, baseColor);
        return `
      background-color: ${lightColor};
      color: ${baseColor};  
    `;
    }}
`

export const IconContainerBlue = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.iconBlue || '#2563eb';
        const lightColor = transparentize(0.87, baseColor);
        return `
      background-color: ${lightColor};
      color: ${baseColor};  
    `;
    }}
`

export const PreferenceContainer = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.preferenceBg || '#f9fafb';
        const lightColor = transparentize(0.87, baseColor);
        return `
      background-color: ${baseColor};
      color: ${theme?.black};  
    `;
    }}
`
export const ValuesNormalCount = styled.span`
  ${({ theme }) => {
        const baseColor = theme?.gray || '#007BFF';
        const lightColor = transparentize(0.85, baseColor);
        const blueColor = theme?.blue || '#007BFF';

        return `
        background-color: ${lightColor};
      color: ${baseColor};
      border-radius: 50%;
  }
    `;
    }}
`;
export const ValuesActiveCount = styled.span`
  ${({ theme }) => {
        const baseColor = theme?.blue || '#007BFF';
        const lightColor = transparentize(0.85, baseColor);

        return `
      background-color: ${baseColor};
      color: #ffffff;
      border-radius: 50%;
    `;

    }}
`;
export const ButtonLeftRightArrow = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.blue || '#007BFF';
        const lightColor = lighten(0.55, baseColor);
        let lightHoverColor = lighten(0.45, baseColor);
        return `
      background-color: ${lightColor};
      color: ${baseColor};
      border: 1px solid transaprent;
      &:hover{
        background-color: ${lightHoverColor};
    }
    `;
    }}
`;

export const AttachmentView = styled.div`
  ${({ theme }) => {
        const baseColor = theme?.blue || '#007BFF';
        const lightColor = transparentize(0.85, baseColor);
        let lightHoverColor = transparentize(0.70, baseColor);
        return `
      background-color: ${lightColor};
      color: ${baseColor};
      border: 1px solid transaprent;
      &:hover{
        background-color: ${lightHoverColor};
    }
    `;
    }}
`;